import {StoppageInfo, StoppageInfoDto} from '@domain/stoppages'
import {ApiClient} from '@hconnect/apiclient'
import {OrderByApiProperty, ApiFilter} from '@hconnect/common/maintain-filters'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const QueryKey = 'stoppages'

type ResponseTypeDto = {
  currentPage: number
  totalCount: number
  data: StoppageInfoDto[]
}
type ResponseType = {
  currentPage: number
  totalCount: number
  data: StoppageInfo[]
}

export const useGetStoppages = ({
  pageSize,
  pageNumber,
  filters,
  orderBy,
  options
}: {
  pageSize: number
  pageNumber: number
  filters?: ApiFilter[]
  orderBy?: OrderByApiProperty[]
  options?: UseQueryOptions<ResponseTypeDto, AxiosError, ResponseType>
}) => {
  return useQuery<ResponseTypeDto, AxiosError, ResponseType>({
    queryKey: [QueryKey, pageSize, pageNumber, orderBy, filters],
    queryFn: async () => {
      const path = '/rootcausefailureanalysis/stoppages'
      return (
        await ApiClient.axiosInstance.post<ResponseTypeDto>(path, {
          pageSize,
          pageNumber: pageNumber + 1, // API is 1-based index
          filters,
          orderBy
        })
      ).data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 2,

    // allow the callee to override the default options
    ...options,

    // map server response
    select: (data) => ({
      ...data,
      data: data.data.map((stoppage) => ({
        ...stoppage,
        id: stoppage.externalMainId
      }))
    })
  })
}
